





























import { Vue, Component, Prop } from 'vue-property-decorator'
import { WingBlank } from '@/components/index'
import { NBMessageBox } from '@/utils/nBMessageBox'
import { ObjectEnble, ObjectDisabled } from '@/api/ObectAdmin'
import { ResAllObjectList } from '@/types/ObjectAdmin'
@Component({
  components: {
    WingBlank,
  },
})
export default class extends Vue {
  /**
   * listArr 展示数据
   *
   * ResAllObjectList 数组数据规则
   */
  @Prop() listArr!: ResAllObjectList[]
  @Prop() getAllObjectList!: Function

  /**
  * 新增， 编辑跳转
   */
  handleEdit(type: string, id:any) {
    this.$router.push({
      path: '/system/add',
      query: {
        type,
        id
      }
    })
  }

  /**
   * 禁用， 启用
   * handleClickDisabled
   */
  async handleClickDisabled(id:number, enabled:number) {
    try {
      const { msg } = await NBMessageBox(this)
      /**
       * 1启用
       * 2禁用
       */
      if (enabled === 1) {
        await ObjectDisabled(id)
      } else {
        await ObjectEnble(id)
      }
      msg()
      this.getAllObjectList()
    } catch (e) {
      e.msg()
    }
  }
}
